import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import setupRouter from "./router";
import store from "./store";
import "./assets/styles/global.scss";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import { localeFromPath } from "./utils/locale";

// The URL decides the language (utils/locale.ts): nothing is stored in the browser.
const locale = localeFromPath(window.location.pathname);

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: "fr",
  messages: { fr, en },
});

const router = setupRouter(i18n);

createApp(App).use(store).use(router).use(i18n).mount("#app");
